import {
    LOGIN,
    LOGIN_SUCCESS,
    LOGIN_FAILED,
    LOGIN_COMPLETED,
    LOGGED_IN,
    LOGGED_OUT,
    LOGOUT,
    GET_USER_INFO,
    GET_USER_INFO_SUCCESS,
    RESET_AUTH_ERROR,
    SET_IS_HAVE_UPLOADS,
    SET_TEMP_TOKEN,
    UPDATE_MFA_STATUS,
    LOGIN_MFA_REQUIRED
} from '../actions/auth';

const initialUser = {
    url: '',
    id: '',
    role: '',
    email: '',
    first_name: '',
    last_name: '',
    doctor: {},
    contactInfo: {},
    healthHistory: {},
    appointments: [],
    medicalConditions: [],
    lastAppointmentSymptoms: []
};

const initialState = {
    isLoggedIn: false,
    loggingIn: false,
    loginError: null,
    tempToken: null,
    signingUp: false,
    hasCheckedAuth: false,
    email: null, 
    loadingUserInfo: false,
    loadedUserInfo: false,
    userType: null,
    loading: false,
    backButton: false,
    user: { ...initialUser }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_TEMP_TOKEN:
            return {
                ...state,
                tempToken: action.payload.tempToken
            };
            case LOGIN_MFA_REQUIRED:
                return {
                    ...state,
                    tempToken: action.payload.tempToken,
                    mfaEnabled: action.payload.mfaEnabled,
                    mfaRequired: action.payload.mfaRequired,
                    email: action.payload.email,
                    loading: false
                };
                case UPDATE_MFA_STATUS:
                    return {
                        ...state,
                        mfaEnabled: action.payload.mfaEnabled
                    };
    case LOGIN:
        return {
            ...state,
            isLoggedIn: false,
            hasCheckedAuth: false,
            loading: true
        };
    case LOGIN_SUCCESS:
        return {
            ...state,
            loggingIn: false,
            isLoggedIn: action.payload.isVerifiedUser? true : false,
            hasCheckedAuth: true,
            user: {
                ...state.user,
                ...action.payload.user
            },
            accessToken: action.payload.accessToken,
            refreshToken: action.payload.refreshToken ?? state.refreshToken,
            tempToken: null, 
            mfaRequired: action.payload.mfaRequired,
            mfaEnabled: action.payload.mfaEnabled,
            loginError: null,
        };
    case LOGIN_FAILED:
        return {
            ...state,
            isLoggedIn: false,
            loggingIn: false,
            loginError: action.payload.error,
            hasCheckedAuth: false,
            userType: null,
        };
    case LOGIN_COMPLETED:
            return {
                ...state,
                loading: false
            };
        return {
            ...state,
            signingUp: false,
            isLoggedIn: false,
            hasCheckedAuth: false,
            userType: null,
            loading: false
        };
    case LOGGED_IN:
        return {
            ...state,
            hasCheckedAuth: true,
            isLoggedIn: true
        };
    case LOGGED_OUT:
        return {
            ...state,
            hasCheckedAuth: true,
            isLoggedIn: false,
            userType: null,
            accessToken: null,
            refreshToken: null,
        };
    case GET_USER_INFO:
        return {
            ...state,
            loadingUserInfo: true
        };
    case GET_USER_INFO_SUCCESS:
        return {
            ...state,
            loadingUserInfo: false,
            loadedUserInfo: true,
            user: action.payload.user
        };
    case LOGOUT:
        return {
            ...state,
            hasCheckedAuth: true,
            isLoggedIn: false,
            userType: null,
            accessToken: null,
            refreshToken: null,
            user: {
                ...initialUser
            }
        };
    case RESET_AUTH_ERROR:
        return {
            ...state,
            signupError: {}
        };

    case SET_IS_HAVE_UPLOADS:
        return {
            ...state,
            user: {
                ...state.user,
                isHaveUploads: action.payload
            }
        };
    default:
        return state;
    }
};
